import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import CountUp from "react-countup";
import up from "../../../../assets/DigitalMarketing/image/dashboard/arrow_up.svg";
import down from "../../../../assets/DigitalMarketing/image/dashboard/arrow down.svg";
import { BsThreeDots } from "react-icons/bs";
import circle from "../../../../assets/DigitalMarketing/image/dashboard/circle_down.svg";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import chatbot from "../../../assets/DigitalMarketing/image/integration/cryptocurrency-color_chat.svg";
import vector from "../../../assets/DigitalMarketing/image/integration/Vector.svg";
import logo from "../../../assets/DigitalMarketing/image/integration/Group 1000002636.svg";
import "../../../assets/DigitalMarketing/Css/Style.css";
import { ChatBotLabel } from "./utils";

function ChatbotDetail() {
  const [show, setshow] = useState(false);
  const dispatch = useDispatch<any>();
  const [searchValue, setSearchValue] = useState("");
  const [branchList, setBranchList] = useState([]);
  const { open, message, openSnackBar, type } = useSnackbar();

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <>
      <Toast open={open} type={type} message={message} />
      <Container fluid>
        <Row className="integration-facebooklayout">
          <Col md={7} className="integration-facebook mt-4">
            <div className="center">
              <img className="icon-img1 mt-1" src={logo} alt="logo" />
              <span>
                <img className="login-logo mt-1" src={vector} alt="vector" />
              </span>
              <span>
                <img className="icon-img3 mt-1" src={chatbot} alt="chatbot" />
              </span>
            </div>
            <h1 className="facebook-message">
              Receive new leads from Chatbot & Integration Lead Ads in your Mind
              and Mom account
            </h1>
            <div className="mx-4">
              <Button className="chatbot-btn mx-1" id="btn-chat">
                {" "}
                Generate URL
              </Button>
            </div>
            <div className="facebook-message">
              {ChatBotLabel.map((item) => (
                <div className="mt-3">
                  <item.tag
                    {...item}
                  />
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
export default React.memo(ChatbotDetail);
